import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'react-bootstrap-icons';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import { withRouter } from 'react-router'
import { MyGlobal } from './GlobalContext';

class NavMenu extends Component {
    static displayName = NavMenu.name;

    allowLoginLevel = ["MM", "SM"];

    constructor(props) {
        super(props);
        this.history = props.history;
        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.navClicked = this.navClicked.bind(this);
        this.state = {
            collapsed: true
        };
    }

    getTitle() {
        let currentPage = window.location.pathname.toLowerCase().replace("/", "");
        let pageNames = ['Warehouse', 'Load Pallet', 'Load Truck', 'Main Menu', 'Tote Approval', 'Tote Move QC', 'Tote Put Away', 'Unload Truck', 'Inwards'];
        let pageName = pageNames.find(e => e.replace(/ /g, '').toLowerCase() == currentPage);
        if (pageName) {
            return pageName;
        }

        switch (currentPage) {
            case "home":
            case "":
                return "Login";
            default:
                return "";
        }
    }

    toggleNavbar(e, hide) {
        hide = hide ?? !this.state.collapsed;
        this.setState({
            collapsed: hide
        });
    }

    navClicked() {
        this.toggleNavbar();
    }

    render() {

        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <ArrowLeft className="" onClick={(e) => { this.toggleNavbar(e, true); this.history.goBack(); }} color="#acadad" size={35}></ArrowLeft>
                        <NavbarBrand >{this.getTitle()}</NavbarBrand>
                        <NavbarBrand className="d-sm-inline-flex flex-sm-row-reverse"  >{MyGlobal.warehouse_name}</NavbarBrand>
                        <NavbarToggler  onClick={this.toggleNavbar} className="mr-2" />
                 
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                {MyGlobal.userAllowed(this.allowLoginLevel) ?
                                    <NavItem>
                                      <NavLink tag={Link} className="text-dark" onClick={this.navClicked} to="/Supervisor/SupervisorMenu">Supervisor Menu</NavLink>
                                    </NavItem> : ""
                                }
                               
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" onClick={this.navClicked} to="/warehouse">Warehouse</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" onClick={this.navClicked} to="/mainmenu">Main Menu</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" onClick={(e) => {
                                        this.navClicked(e);
                                        MyGlobal.logout();
                                    }} to="/#">Log out </NavLink>
                                </NavItem>
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}

export default withRouter(NavMenu);
